module.exports = __webpack_public_path__ + "static/media/ic_info_blue.e949cf3f.svg";